<div class="image-container" *ngIf="imageConf.current || previewImage">
  <div class="placeholder">{{ placeholder | translate }}</div>
  <div class="preview-container" (click)="onFocus()">
    <div class="preview-image">
      <img *ngIf="imageConf.current && !previewImage && imageHost"
           src="{{ imageHost + imageConf.current }}"
           alt="{{ placeholder | translate }}" />
      <img *ngIf="previewImage"
           src="{{ previewImage }}"
           alt="{{ placeholder | translate }}" />
      <button mat-icon-button
              class="remove-button"
              [disabled]="disabled"
              matTooltip="{{ 'Remove_image' | translate }}"
              [matTooltipPosition]="'above'"
              (click)="onRemoveImageClicked()">
        <mat-icon color="warn">remove_circle</mat-icon>
      </button>
    </div>
  </div>
  <div *ngIf="hint"
       class="preview-hint">
    {{ hint }}
  </div>
</div>
<div class="hidden">
  <input #fileInput class="file-input"
         type="file"
         tabIndex="-1"
         (change)="onFileSelectionChange($event)"
         accept="{{ '.' + allowedExtensions.join(',.') }}">
  <mat-form-field *ngIf="!imageConf.current && !previewImage"
                  color="accent">
    <input #textInput matInput
           type="text"
           maxlength="1"
           placeholder="{{ placeholder | translate }}"
           [(ngModel)]="textInputAutoRemove"
           [formControl]="imageFormControl"
           (click)="onFocus()"
           (keyup)="onTextChange()">
    <mat-hint *ngIf="hint" align="end">{{ hint }}</mat-hint>
    <mat-error *ngIf="imageFormControl.hasError('extension')">{{ 'Image_extension_error' | translate:{extension: allowedExtensions.join(', ')} }}</mat-error>
    <mat-error *ngIf="imageFormControl.hasError('size')">{{ 'Image_size_error' | translate:{size: maxFileSize+' Mo'} }}</mat-error>
  </mat-form-field>
</div>

<!--    custom image input-->
<div class="file-input image-input" (click)="openFileBrowser()" *ngIf="!imageConf.current && !previewImage"
     (dragover)="onImageDragOver($event)" (dragleave)="onImageDragLeave($event)" (drop)="onImageDrop($event)"
     [class.dragging]="isDragging">
  <div class="preview">
    <mat-icon aria-hidden="false" aria-label="video add icon" fontIcon="add_photo_alternate"></mat-icon>
    <div class="preview-text">{{ 'Add_image_drag_drop' | translate }}</div>
    <div class="hint" >
      {{ hint }}
    </div>
  </div>
</div>
